/* eslint-disable vue/no-use-v-if-with-v-for */
<template>
  <v-navigation-drawer fixed permanent :mini-variant="miniVariant"
    app width="170" mini-variant-width="50">
    <v-list dense v-if="cargado && !rolCliente && !rolProveedor">
      <v-list-item @click="miniVariant = !miniVariant">
        <v-icon size="32" color="white">menu</v-icon>
      </v-list-item>
      <v-list-item link v-for="(item, i) in itemsFiltrados"
        @click="goToRoute(item.to.name)" :key="i">
        <v-tooltip right v-if="miniVariant">
          <template v-slot:activator="{ on }">
              <v-list-item-icon v-on="on">
                <v-icon size="32" color="white">{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content v-on="on">
                <v-list-item-title>
                  {{ $t('navDrawer.' + item.title) }}
                </v-list-item-title>
              </v-list-item-content>
          </template>
          <span>{{ $t('navDrawer.' + item.title) }}</span>
        </v-tooltip>
        <template v-else>
          <v-list-item-icon>
            <v-icon size="32" color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ $t('navDrawer.' + item.title) }}
            </v-list-item-title>
          </v-list-item-content>
        </template>

      </v-list-item>
    </v-list>

    <v-list dense v-if="cargado && rolCliente && configuracion.clienteCrearIncidenciasWeb">
      <v-list-item @click="miniVariant = !miniVariant">
        <v-icon size="32" color="white">menu</v-icon>
      </v-list-item>
      <v-list-item link v-for="(item, i) in itemsRolClienteCreaIncidencias"
        @click="goToRoute(item.to.name)" :key="i">
        <template >
          <v-list-item-icon>
            <v-icon size="32" color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ $t('navDrawer.' + item.title) }}
            </v-list-item-title>
          </v-list-item-content>
          </template>
      </v-list-item>
    </v-list>

    <v-list dense v-if="cargado && rolCliente && !configuracion.clienteCrearIncidenciasWeb">
      <v-list-item @click="miniVariant = !miniVariant">
        <v-icon size="32" color="white">menu</v-icon>
      </v-list-item>
      <v-list-item link v-for="(item, i) in itemsRolCliente"
        @click="goToRoute(item.to.name)" :key="i">
        <template >
          <v-list-item-icon>
            <v-icon size="32" color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ $t('navDrawer.' + item.title) }}
            </v-list-item-title>
          </v-list-item-content>
          </template>
      </v-list-item>
    </v-list>

    <v-list dense v-if="cargado && rolProveedor && !proveedorCrearIncidenciasWeb">
      <v-list-item @click="miniVariant = !miniVariant">
        <v-icon size="32" color="white">menu</v-icon>
      </v-list-item>
      <v-list-item link v-for="(item, i) in itemsRolProveedor"
        @click="goToRoute(item.to.name)" :key="i">
        <template >
          <v-list-item-icon>
            <v-icon size="32" color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ $t('navDrawer.' + item.title) }}
            </v-list-item-title>
          </v-list-item-content>
          </template>
      </v-list-item>
    </v-list>

    <v-list dense v-if="cargado && rolProveedor && proveedorCrearIncidenciasWeb">
      <v-list-item @click="miniVariant = !miniVariant">
        <v-icon size="32" color="white">menu</v-icon>
      </v-list-item>
      <v-list-item link v-for="(item, i) in itemsRolProveedorCrearIncidencias"
        @click="goToRoute(item.to.name)" :key="i">
        <template >
          <v-list-item-icon>
            <v-icon size="32" color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ $t('navDrawer.' + item.title) }}
            </v-list-item-title>
          </v-list-item-content>
          </template>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      cargado: false,
      miniVariant: true,
      singleTipoSolicitudActivo: '',
      itemsRolCliente: [
        {
          icon: 'mdi-clipboard-list-outline',
          title: 'listaSolicitudes',
          to: {
            name: 'solicitudesRolCliente'
          },
          exact: true,
          verCliente: false
        }
      ],
      itemsRolClienteCreaIncidencias: [
        {
          icon: 'mdi-clipboard-list-outline',
          title: 'listaSolicitudes',
          to: {
            name: 'solicitudesRolCliente'
          },
          exact: true,
          verCliente: false
        },
        {
          icon: 'mdi-newspaper-plus',
          title: 'visitaConSolicitud',
          to: {
            name: 'nuevaVisitaSolicitud'
          },
          exact: true,
          verCliente: true
        }
      ],
      items: [
        {
          icon: 'home',
          title: 'home',
          to: {
            name: 'home'
          },
          exact: true
        },
        {
          icon: 'mdi-clipboard-list-outline',
          title: 'listaSolicitudes',
          to: {
            name: 'incidencias'
          },
          exact: true
        },
        {
          icon: 'mdi-newspaper-plus',
          title: 'nuevaVisita',
          to: {
            name: 'nueva-visita'
          },
          exact: true
        },
        {
          icon: 'work',
          title: 'maestros',
          to: {
            name: 'maestros'
          },
          exact: true
        },
        {
          icon: 'chat',
          title: 'chat',
          to: {
            name: 'chat'
          },
          exact: true
        },
        {
          icon: 'mdi-text-box-multiple',
          title: 'informes',
          to: {
            name: 'informes'
          },
          exact: true
        },
        {
          icon: 'settings',
          title: 'configuracion',
          to: {
            name: 'configuracion'
          },
          exact: true
        },
        {
          icon: 'mdi-office-building-cog-outline',
          title: 'gestion',
          to: {
            name: 'gestion'
          },
          exact: true,
          verCliente: false
        }
      ]

      // if (this.configuracion.permitirAsignarPromocionesProveedor ) {

      // }
    }
  },
  computed: {
    ...mapGetters({
      estaIndustrial: 'login/estaIndustrial',
      tiposSolicitud: 'configuracion/getTiposSolicitud',
      configuracion: 'configuracion/getConfiguracion',
      idubapi: 'login/idubapi',
      rolProveedor: 'login/rolProveedor',
      usuario: 'login/usuario'
    }),
    itemsRolProveedor () {
      let items =  [
        {
          icon: 'mdi-clipboard-list-outline',
          title: 'listaSolicitudes',
          to: {
            name: 'incidencias'
          },
          exact: true
        }
      ]
      
      if ( this.accesoTodasIncidencias  || this.permisosExtraProveedor ) {
        items.push({
          icon: 'mdi-text-box-multiple',
          title: 'informes',
          to: {
            name: 'informes'
          },
          exact: true
        })
      } 

      return items
    },
    itemsRolProveedorCrearIncidencias () {
      let items = [
        {
          icon: 'mdi-clipboard-list-outline',
          title: 'listaSolicitudes',
          to: {
            name: 'incidencias'
          },
          exact: true
        },
        {
          icon: 'mdi-newspaper-plus',
          title: 'nuevaVisita',
          to: {
            name: 'nueva-visita'
          },
          exact: true
        }
      ]
      
      if ( this.accesoTodasIncidencias || this.permisosExtraProveedor ) {
        items.push({
          icon: 'mdi-text-box-multiple',
          title: 'informes',
          to: {
            name: 'informes'
          },
          exact: true
        })
      }

      return items
    },
    itemsFiltrados () {
      let retorno = []
        if (this.items) {
          retorno = retorno.concat(this.items)
          if(this.rolAdmin === false){
            if (this.idubapi.motor === 'SIN_BD') {
              retorno = retorno.filter(x => x.to.name !== 'chat')
            }
            retorno = retorno.filter(x => x.to.name !== 'gestion')
          }
          else
          {
            retorno = retorno.filter(x => x.to.name === 'gestion')
          }

          if ( this.idubapi.restriccionesCliente.restringirAccesoConfigPV == 1) {
            retorno = retorno.filter(x => x.to.name !== 'configuracion')
          }
        }
      return retorno
    },
    rolCliente () {
      return this.$store.state.login.rolCliente
    },
    rolAdmin () {
      return this.$store.state.login.rolAdmin
    },
    proveedorCrearIncidenciasWeb(){
      if(this.rolProveedor){
        if(this.idubapi.PERMISOS_ROL_PROVEEDOR_WEB.ALTA_INCIDENCIAS === "1" || this.idubapi.PERMISOS_ROL_PROVEEDOR_WEB.ALTA_INCIDENCIAS === 1){
          return true;
        }
      }
      return false;
    },
    accesoTodasIncidencias() {
      return this.idubapi.PERMISOS_ROL_PROVEEDOR_WEB.ACCESO_TODAS_INCIDENCIAS == "1" ? true : false
    },
    permisosExtraProveedor() {
      return this.rolProveedor && this.configuracion.PV_PERMISOS_EXTRA_PROVEEDOR
    }
  },
  methods: {
    ...mapActions({
      setearRol: 'login/setearRol'
    }),
    goToRoute(routeName) {
      let routerObj = {
        name: routeName
      }
      if (this.tiposSolicitud.length === 1 && parseInt(this.tiposSolicitud[0].codigoTipoSolicitud) > 1) {
        routerObj.query = { codigoTipoSolicitudes: this.tiposSolicitud[0].codigoTipoSolicitud }
        this.$router.push(routerObj).catch(err => { console.log(err)})
      } else {
        this.$router.push(routerObj).catch(err => { console.log(err)})
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.cargado = true
    }, 500)
  },
  watch: {
    async itemsFiltrados(){
      await this.setearRol()
    }
  }
}
</script>

<style scoped>
.v-list-item__content {
  color: #FFF;
  font-weight: bold;
}
.v-list-item__icon {
  margin-right: 12px !important;
}
</style>



